import { truckModeEnum, truckRenterPriceTypeEnum } from '../enums';

export const isTruckContextEnabled = (
    mode: number | undefined,
    context: 'departure' | 'arrival' | 'transfer' | 'onSite' | 'secondTimeOnSite'
): boolean => {
    if (mode == null || isNaN(mode)) return false;
    switch (context) {
        case 'departure':
            return [truckModeEnum.APPRO, truckModeEnum.POSE, truckModeEnum.DOUBLEFRET].includes(mode);
        case 'arrival':
            return [
                truckModeEnum.EVAC,
                truckModeEnum.ENLEVEMENT,
                truckModeEnum.ROTATION,
                truckModeEnum.BACKANDFORTH,
                truckModeEnum.DOUBLEFRET,
            ].includes(mode);
        case 'transfer':
            return mode === truckModeEnum.TRANSFER;
        case 'onSite':
            return mode === truckModeEnum.ONSITE;
        case 'secondTimeOnSite':
            return [truckModeEnum.BACKANDFORTH].includes(mode);
        default:
            return false;
    }
};

export const getTruckPriceTypeConfig = (priceType: number) => {
    switch (priceType) {
        case truckRenterPriceTypeEnum.DAY:
            return { step: 0.5, min: 0, decimals: 1, max: 1 };

        case truckRenterPriceTypeEnum.TON:
            return { step: 0.01, min: 0, decimals: 2 };

        case truckRenterPriceTypeEnum.UNIT:
        default:
            return { step: 1, min: 0, decimals: 0 };
    }
};
